import { Session } from 'smg/customer-api/session';
import { CategoryDescriptionsFromDocument, InitEmailPreferencesPanel } from 'smg/email-preferences-page';
import { InitSmsPreferencesPanel } from 'smg/sms-preferences-panel';

import { AccountReady } from '../account-session';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }
    InitEmailPreferencesPanel({ mode: 'session', categoryDescriptions: CategoryDescriptionsFromDocument() });
    const smsPanel = InitSmsPreferencesPanel({ mode: 'session', categoryDescriptions: CategoryDescriptionsFromDocument('#sprefs-categories') });
    // As in the design: the "These settings are for" line is absent while the
    // page loads and appears once the session names the account.
    const $owner = document.querySelector('#notif-owner') as HTMLElement;
    const $email = document.querySelector('#notif-email') as HTMLElement;
    void Session().then(sess => {
        $email.textContent = sess.user.emailAddress.email ?? '';
        $owner.classList.remove('d-none');
        smsPanel.setPhone(sess.user.phoneNumber.phone ?? '');
    }).catch(() => undefined);
}
